import FilterDateInput from "@/components/Common/FilterDateInput/FilterDateInput.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import FilterConfigDialog from "@/components/Events/FilterConfigDialog/FilterConfigDialog.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import "./EventFilter.scss";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import { canParseJson, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { uniqBy } from "lodash";

export default {
  name: "EventFilter",
  props: [
    "filter",
    "categoryGroups",
    "groupedOrganizer",
    "groupedLocations",
    "featureGroups",
    "isLoading",
    "organizer",
    "locations",
    "channels",
    "cities",
    "users",
    "workflowFilter"
  ],
  components: {
    FilterConfigDialog,
    FilterDateInput,
    TreeViewSelection
  },
  data: function() {
    return {
      panels: [],
      featureListKey: 0,
      hideCancelled: false,
      savedFilters: [],
      selectedSavedFilter: "",
      regionality: [
        { title: "regional", value: "communal" },
        { title: "lokal", value: "local" },
        { title: "überregional", value: "regional" },
        { title: "intern", value: "internal" }
      ],
      operator: "$and",
      query: {
        [this.operator]: []
      },
      defaultQuery: {
        $and: []
      },
      filterOptions: [
        { name: "allen", value: "$and" },
        { name: "mindestens einer", value: "$or" }
      ],
      selectOptions: [
        { name: "Ist", value: "$eq", optionFor: ["singular", "date"] },
        { name: "Ist nicht", value: "$ne", optionFor: ["singular", "date"] },
        { name: "Ist", value: "$in", optionFor: ["multiple"] },
        { name: "Ist nicht", value: "$nin", optionFor: ["multiple"] },
        { name: "Vor", value: "$lt", optionFor: ["date"] },
        { name: "Nach", value: "$gt", optionFor: ["date"] }
      ],
      normalizedCitiesSelectOptions: [
        { name: "Ist mindestens eins", value: "$in", optionFor: ["multiple"] },
        { name: "Ist keins von", value: "$nin", optionFor: ["multiple"] }
      ],
      selectableFilter: [
        { name: "Besitzer", value: "owner" },
        { name: "Highlight", value: "highlight" },
        { name: "Kanäle", value: "channels" },
        { name: "Kategorie", value: "category" },
        { name: "Mandanten", value: "principal_id" },
        { name: "Merkmale", value: "features" },
        {
          name: "Regionalität",
          value: "regionality"
        },
        { name: "Standort (Ort)", value: "locationObj.address.city" },
        {
          name: "Standort (übergeordnet)",
          value: "locationObj.address.normalized_city"
        },
        { name: "Standort (Titel)", value: "location" },
        { name: "Einzel-/Serientermin", value: "type" },
        { name: "Veranstalter", value: "operator" },
        { name: "Aktiv (Veröffentlicht)", value: "active" },
        {
          name: "Geändert am",
          value: "change_date"
        },
        {
          name: "Erstellt am",
          value: "create_date"
        }
      ],
      selectableEventTypes: [
        { name: "Einzeltermin", value: "basic" },
        { name: "Serie", value: "series" }
      ],
      treeviewFilterOptions: [
        "category",
        "features",
        "location",
        "operator",
        "locationObj.address.normalized_city"
      ],
      dateInputFilterOptions: ["change_date", "create_date"],
      selectedFilter: ["types"],
      multiSelectKeys: [
        "location",
        "features",
        "operator",
        "category",
        "locationObj.address.normalized_city"
      ],
      featuresDialog: false,
      displayCategoryTreeview: [false],
      displayFeaturesTreeview: [false],
      values: [],
      features: [],
      categorys: [],
      mappedCategoryTypes: [],
      mappedChannels: [],
      mappedRegionality: [],
      mappedUsers: [],
      deleted: false,
      declined: false,
      distinct: false,
      dialog: false,
      moment
    };
  },
  async mounted() {
    this.selectableFilter.find(
      filter => filter.name === "Highlight"
    ).value = `highlight.${this.eventConfig.useHighlightFrom}`;
    await this.getSavedFilters();
    await this.getContentFromLocalStorage();
  },
  methods: {
    async getContentFromLocalStorage() {
      this.getLocalStorageItems();
      delete this.filter.isDefault;
      await this.updateFilter();
    },

    getLocalStorageItems() {
      const eventFilterPrincipal = localStorage.getItem("eventFilterPrincipal");
      if (eventFilterPrincipal === this.$store.state.selectedPrincipal._id) {
        const storedQuery = localStorage.getItem("eventsQuery");
        if (!this.query) this.query = cloneDeep(this.defaultQuery);
        else {
          this.query = canParseJson(storedQuery)
            ? JSON.parse(storedQuery)
            : cloneDeep(this.defaultQuery);
        }

        const storedOperator = localStorage.getItem("operator");
        this.operator = storedOperator ? storedOperator : "$and";

        let filterStart = localStorage.getItem("eventsStartDate");
        let filterEnd = localStorage.getItem("eventsEndDate");

        if (filterStart === "undefined") filterStart = moment().toISOString();
        if (filterEnd === "undefined") filterEnd = "";
        this.filter.start = filterStart;
        this.filter.end = filterEnd;

        this.hideCancelled = localStorage.getItem("hideCancelled");
        this.hideCancelled = this.hideCancelled === "true";
        if (this.hideCancelled) this.filter.hideCancelled = true;

        const distinct = localStorage.getItem("eventsDistinct");
        this.distinct = distinct ? JSON.parse(distinct) : false;
      } else {
        this.operator = "$and";
        this.query = cloneDeep(this.defaultQuery);
        this.filter.start = moment().toISOString();
        this.filter.end = "";
        this.distinct = false;
      }
      if (this.query && this.query[this.operator]?.length) {
        this.query[this.operator].forEach((filter, index) => {
          this.setItems(filter, index);
        });
      }
    },

    setFilterEnd() {
      let formatedDate = new Date(this.filter.end);
      formatedDate.setMinutes(formatedDate.getMinutes() - 1);
      this.filter.end = moment(formatedDate).toISOString();
      this.$emit("applyFilter", this.filter);
    },

    async updateFilter(reset) {
      if (!reset) await this.validateQuery();
      this.filter.query = this.query;
      this.filter.distinct = this.distinct;
      this.cleanupMultipleFilter();
      this.setLocalStorageItems();
      await this.$emit("applyFilter");
      this.panels.splice(0, 1);
      if (reset || !this.query[this.operator])
        this.query = { [this.operator]: [] };
    },

    setLocalStorageItems() {
      localStorage.setItem("eventsQuery", JSON.stringify(this.query));
      localStorage.setItem(
        "eventFilterPrincipal",
        this.$store.state.selectedPrincipal._id
      );
      localStorage.setItem("operator", this.operator);
      localStorage.setItem("eventsStartDate", this.filter.start);
      localStorage.setItem("eventsEndDate", this.filter.end);
      localStorage.setItem("eventsDistinct", this.distinct);
    },

    async selectSavedFilter(value) {
      const foundFilter = this.savedFilters.find(
        filter => filter._id === value
      );
      if (foundFilter) {
        const queryObj = JSON.parse(foundFilter.query);
        if (queryObj) {
          const keys = Object.keys(queryObj);
          this.operator = keys[0];
          this.query = queryObj;
          this.query[this.operator].forEach((filterObj, index) => {
            this.setItems(filterObj, index);
          });
        }
      }
    },

    checkIfPrincipalFilter(filter) {
      return this.savedFilters.find(f => f._id === filter)?.isPrincipalFilter;
    },

    async removeSavedFilter(filter) {
      const removeText = filter.isPrincipalFilter
        ? "Möchten Sie diesen Filter wirklich löschen? ACHTUNG: Dieser Filter steht danach allen Benutzern nicht mehr zur Verfügung!"
        : "Möchten Sie diesen Filter wirklich löschen?";
      const confirm = await this.$confirm(removeText, confirmWarningConfig);

      if (confirm) {
        const headers = getTokenHeader();
        const user = this.$store.state.currentUser;
        const principal = this.$store.state.selectedPrincipal;

        const filterObj = this.savedFilters.find(f => f._id === filter);
        const leftFilters = this.savedFilters.filter(f => f._id !== filter);
        if (filterObj?.isPrincipalFilter && !this.isEventAdmin) return;
        if ((user?._id || principal?._id) && headers) {
          try {
            let response;
            if (filterObj?.isPrincipalFilter) {
              response = await axios.delete(
                `${env.auth_api_client_url}principals/filter/${principal._id}`,
                {
                  params: {
                    filter: JSON.stringify(leftFilters)
                  },
                  headers
                }
              );
            } else {
              response = await axios.delete(
                `${env.auth_api_client_url}users/filter/${user._id}`,
                {
                  params: {
                    filter: JSON.stringify(leftFilters)
                  },
                  headers
                }
              );
            }
            if (response.status !== 200)
              await this.$store.dispatch("createError");
            else {
              this.$store.dispatch(
                "createSuccess",
                "Filter erfolgreich gelöscht"
              );
              await this.getSavedFilters();
              this.selectedSavedFilter = "";
            }
          } catch (e) {
            await this.$store.dispatch("createError", e);
          }
        }
      }
    },

    async getSavedFilters() {
      const headers = getTokenHeader();
      const user = this.$store.state.currentUser;
      const principal = this.$store.state.selectedPrincipal;
      if (user?._id && principal?._id && headers) {
        try {
          const principalResponse = await axios.get(
            `${env.auth_api_client_url}principals/filter/${this.$store.state.selectedPrincipal._id}`,
            { headers }
          );
          const userResponse = await axios.get(
            `${env.auth_api_client_url}users/filter/${user._id}`,
            { headers }
          );
          const userFilters = Array.isArray(userResponse?.data?.filter)
            ? userResponse.data.filter
            : [];
          const principalFilters = Array.isArray(
            principalResponse?.data?.filter
          )
            ? principalResponse.data.filter.map(filter => ({
                ...filter,
                isPrincipalFilter: true
              }))
            : [];

          this.savedFilters = principalFilters.concat(userFilters);
        } catch (e) {
          console.error(e);
          await this.$store.dispatch("createError", e);
        }
      }
    },

    async savePrincipalFilter(filter) {
      try {
        const headers = getTokenHeader();

        const response = await axios.post(
          `${env.auth_api_client_url}principals/filter`,
          filter,
          { headers }
        );
        if (response.status !== 201) await this.$store.dispatch("createError");
        else {
          await this.$store.dispatch("createSuccess", "Filter gespeichert!");
          await this.getSavedFilters();
          this.savedFilters = response?.data?._id;
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    },

    async saveUserFilter(filter) {
      try {
        const headers = getTokenHeader();

        const response = await axios.post(
          `${env.auth_api_client_url}users/filter`,
          filter,
          { headers }
        );
        if (response.status !== 201) await this.$store.dispatch("createError");
        else {
          await this.$store.dispatch("createSuccess", "Filter gespeichert!");
          await this.getSavedFilters();
          this.selectedSavedFilter = response?.data?._id;
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    },

    async saveFilter(filterObj) {
      filterObj.type = "events";
      if (filterObj.saveFor === "user") await this.saveUserFilter(filterObj);
      else await this.savePrincipalFilter(filterObj);
    },

    cleanupMultipleFilter() {
      if (this.query[this.operator]) {
        this.query[this.operator].forEach((key, index) => {
          const currentKey = Object.keys(key)[0];
          if (this.multiSelectKeys.includes(currentKey)) {
            const keyObj = this.query[this.operator][index][currentKey];
            if (keyObj.$eq) {
              this.query[this.operator][index][currentKey] = {
                $in: keyObj.$eq
              };
            } else if (keyObj.$ne) {
              this.query[this.operator][index][currentKey] = {
                $nin: keyObj.$ne
              };
            }
          }
        });
      } else {
        this.query = cloneDeep(this.defaultQuery);
      }
    },

    async validateQuery() {
      let deleteableIndexes = [];
      this.query[this.operator]?.forEach((key, index) => {
        const keyValue = this.firstPropertyOfFirstProperty(key);
        if (keyValue && (keyValue === "true" || keyValue === "false"))
          this.stringToBoolean(key); //fixes true/false for json
        if (keyValue === undefined || keyValue === "")
          deleteableIndexes.push(index);
      });
      deleteableIndexes = deleteableIndexes.sort(function(a, b) {
        return b - a;
      });
      deleteableIndexes.forEach(i => this.deleteFilter(i));
      if (!this.query[this.operator]?.length) this.query = {};
    },

    stringToBoolean(filterObj) {
      const key = Object.keys(filterObj)[0];
      filterObj[key][Object.keys(filterObj[key])[0]] = JSON.parse(
        filterObj[key][Object.keys(filterObj[key])[0]]
      );
    },

    setOperator(newOperator) {
      const oldOperator = Object.keys(this.query)[0];
      if (oldOperator !== newOperator) {
        this.query = {
          [newOperator]: this.query[this.operator]
        };
        this.operator = newOperator;
      }
    },

    addFilter() {
      if (this.mappedCategoryTypes.length) {
        this.query[this.operator].push({ categoryGroup: { $eq: "" } });
        this.values[
          this.query[this.operator].length - 1
        ] = this.mappedCategoryTypes;
      } else {
        this.query[this.operator].push({
          [`highlight.${this.eventConfig.useHighlightFrom}`]: { $eq: "" }
        });
        this.values[this.query[this.operator].length - 1] = [
          {
            name: "Ja",
            value: true
          },
          { name: "Nein", value: false }
        ];
      }
    },

    deleteFilter(index) {
      this.query[this.operator].splice(index, 1);
      this.query[this.operator].forEach((key, index) => {
        this.setItems(key, index);
      });
    },

    setFilterKey(filterObj, newKey, index) {
      const oldKey = Object.keys(filterObj)[0];
      if (oldKey !== newKey) {
        filterObj[newKey] = filterObj[oldKey];
        delete filterObj[oldKey];
      }
      this.setItems(filterObj, index);
    },

    setDbOperator(filterObj, newOperator) {
      const key = Object.keys(filterObj)[0];
      if (
        filterObj[key] === null ||
        filterObj[key] === undefined ||
        typeof filterObj[key] !== "object"
      ) {
        filterObj[key] = {};
      }
      const oldOperator = Object.keys(filterObj[key])[0];
      if (oldOperator !== newOperator) {
        filterObj[key][newOperator] = filterObj[key][oldOperator];
        delete filterObj[key][oldOperator];
      }
    },

    setValue(filterObj, value) {
      const key = Object.keys(filterObj)[0];
      const operator = Object.keys(filterObj[key])[0];
      filterObj[key][operator] = value;
    },

    getFilterValue(value) {
      if (value === "categoryGroup") {
        this.mappedCategoryTypes = this.categoryGroups.map(
          type => (type = { name: type.title, value: type._id })
        );
      }
      if (value === "locationObj.address.city") {
        return this.mappedLocations;
      }
      if (value === "locationObj.address.normalized_city") {
        return this.mappedLocationsNormalized;
      }
      if (value === "channels") {
        this.mappedChannels = this.channels.map(
          channel => (channel = { name: channel.title, value: channel.value })
        );
      }
      if (value === "regionality") {
        this.mappedRegionality = this.regionality.map(
          regionality =>
            (regionality = {
              name: regionality.title,
              value: regionality.value
            })
        );
      }
      if (value === "owner") {
        this.mappedUsers = this.users.map(
          user =>
            (user = {
              name: `${user.first_name} ${user.last_name}`,
              value: user._id
            })
        );
      }
    },

    getSelectOptionsForFilterValue(value) {
      if (value === "locationObj.address.normalized_city")
        return this.normalizedCitiesSelectOptions;
      if (this.multiSelectKeys.includes(value)) {
        return this.selectOptions.filter(option =>
          option.optionFor.includes("multiple")
        );
      }
      if (this.dateInputFilterOptions.includes(value)) {
        return this.selectOptions.filter(option =>
          option.optionFor.includes("date")
        );
      }
      return this.selectOptions.filter(option =>
        option.optionFor.includes("singular")
      );
    },

    setItems(filterObj, index) {
      const key = Object.keys(filterObj)[0];
      //INFO: Needed to be reactive
      this.query[this.operator].reverse().reverse();
      switch (key) {
        case "categoryGroup":
          this.values[index] = this.mappedCategoryTypes;
          break;
        case "locationObj.address.city":
          this.values[index] = this.mappedLocations;
          break;
        case "locationObj.address.normalized_city":
          this.values[index] = this.mappedLocationsNormalized;
          break;
        case "principal_id":
          this.values[index] = this.mappedPrincipals;
          break;
        case "regionality":
          this.values[index] = this.mappedRegionality;
          break;
        case "channels":
          this.values[index] = this.mappedChannels;
          break;
        case "owner":
          this.values[index] = this.mappedUsers;
          break;
        case "type":
          this.values[index] = this.selectableEventTypes;
          break;
        case "highlight.standard":
        case "highlight.own":
        case "active":
          this.values[index] = [
            { name: "Ja", value: true },
            { name: "Nein", value: false }
          ];
          break;
        case "category":
          this.displayCategoryTreeview[index] = true;
          break;
        case "features":
          this.displayFeaturesTreeview[index] = true;
          break;
        case "change_date":
        case "create_date":
          this.values[index] = moment().format("DD.MM.YYYY");
          break;
        default:
          this.values[index] = [];
          break;
      }
      // INFO: needed to be reactive
      this.values.reverse().reverse();
    },

    async resetFilter() {
      this.filter.start = moment().toISOString();
      this.filter.end = "";
      this.deleted = false;
      this.distinct = false;
      this.deeclined = false;
      this.hideCancelled = false;
      this.filter.hideCancelled = false;
      this.selectedUserFilter = "";
      this.query = {};
      await this.updateFilter(true);
      this.operator = "$and";
      this.query = cloneDeep(this.defaultQuery);
    },

    async filterForFirstMoment() {
      if (this.distinct) {
        this.filter.distinct = true;
        localStorage.setItem("eventsDistinct", true);
        await this.updateFilter(false);
      } else {
        delete this.filter.distinct;
        localStorage.removeItem("eventsDistinct");
        await this.updateFilter(false);
      }
    },

    async filterWithoutCancelledEvents() {
      if (this.hideCancelled) {
        this.filter.hideCancelled = true;
        localStorage.setItem("hideCancelled", true);
        await this.updateFilter(false);
      } else {
        delete this.filter.hideCancelled;
        localStorage.removeItem("hideCancelled");
        await this.updateFilter(false);
      }
    },

    async filterForDeletedEvents() {
      if (this.deleted) {
        this.query = {
          deleted: this.deleted
        };
        this.filter.query = this.query;
        this.panels.splice(0, 1);
        await this.$emit("applyFilter");
      } else await this.resetFilter();
    },

    async filterForDeclinedEvents() {
      if (this.declined) {
        this.query = {
          declined: this.declined
        };
        this.filter.query = this.query;
        this.panels.splice(0, 1);
        await this.$emit("applyFilter");
      } else await this.resetFilter();
    },

    firstPropertyOfFirstProperty(filterObj) {
      return filterObj[Object.keys(filterObj)[0]][
        Object.keys(filterObj[Object.keys(filterObj)[0]])[0]
      ];
    },

    async updateValue(filterObj, value) {
      if (!isNaN(value)) value = parseInt(value);
      const key = Object.keys(filterObj)[0];
      const operator = Object.keys(filterObj[key])[0];
      if (Array.isArray(value) && !this.multiSelectKeys.includes(key))
        filterObj[key][operator] = value[0];
      else filterObj[key][operator] = value;
    },

    mapKey(key) {
      switch (key) {
        case "principal_id":
          return "Mandant";
        case "owner":
          return "Besitzer";
        case "highlight.standard":
        case "highlight.own":
          return "Highlight";
        case "category":
          return "Kategorie";
        case "features":
          return "Merkmal";
        case "locationObj.address.city":
          return "Standort (Ort)";
        case "locationObj.address.normalized_city":
          return "Standort (übergeordnet)";
        case "location":
          return "Standort (Titel)";
        case "operator":
          return "Veranstalter";
        case "active":
          return "Aktiv (Veröffentlicht)";
        case "channels":
          return "Kanäle";
        case "regionality":
          return "Regionalität";
        case "type":
          return "Einzel-/Serientermin";
        case "change_date":
          return "Geändert am";
        case "create_date":
          return "Erstellt am";
        default:
          return key;
      }
    },

    mapOp(op) {
      switch (op) {
        case "$eq":
          return "Ist";
        case "$ne":
          return "Ist nicht";
        case "$in":
          return "Ist";
        case "$nin":
          return "Ist nicht";
        case "$lt":
          return "Vor";
        case "$gt":
          return "Nach";
        default:
          return "";
      }
    },

    getCategoryTitle(categories) {
      const foundCategories = [];
      categories.forEach(catValue => {
        const foundCategoryGroup = this.categoryGroups.find(catGroup =>
          catGroup.categories.find(cat => cat._id === catValue)
        );
        if (foundCategoryGroup?._id) {
          const foundCategory = foundCategoryGroup.categories.find(
            cat => cat._id === catValue
          );
          if (foundCategory?.title) foundCategories.push(foundCategory.title);
        }
      });
      return foundCategories.join(", ");
    },

    getFeatureTitle(features) {
      const foundFeatures = [];
      features.forEach(featureValue => {
        const foundFeatureGroup = this.featureGroups.find(featureGroup =>
          featureGroup.features.find(feature => feature._id === featureValue)
        );
        if (foundFeatureGroup?._id) {
          const foundFeature = foundFeatureGroup.features.find(
            cat => cat._id === featureValue
          );
          if (foundFeature?.title) foundFeatures.push(foundFeature.title);
        }
      });
      return foundFeatures.join(", ");
    },

    getLocationTitle(locations) {
      const foundLocations = [];
      locations.forEach(locationValue => {
        const foundLocationGroup = this.groupedLocations.find(groupedLocation =>
          groupedLocation.sub.find(location => location._id === locationValue)
        );
        if (foundLocationGroup?._id) {
          const foundLocation = foundLocationGroup.sub.find(
            location => location._id === locationValue
          );
          if (foundLocation?.title) foundLocations.push(foundLocation.title);
        }
      });
      return foundLocations.join(", ");
    },

    getOperatorTitle(operators) {
      const foundoperators = [];
      operators?.forEach(operatorValue => {
        const foundOperatorGroup = this.groupedOrganizer.find(
          groupedOrganizer =>
            groupedOrganizer.sub.find(
              organizer => organizer._id === operatorValue
            )
        );
        if (foundOperatorGroup?._id) {
          const foundLocation = foundOperatorGroup.sub.find(
            location => location._id === operatorValue
          );
          if (foundLocation?.title) foundoperators.push(foundLocation.title);
        }
      });
      return foundoperators.join(", ");
    },

    mapValue(key, value) {
      switch (key) {
        case "principal_id":
          return this.mappedPrincipals.find(
            mPrincipal => mPrincipal.value === value
          )?.name;
        case "owner":
          return this.mappedUsers.find(mUser => mUser.value === value)?.name;
        case "highlight.standard":
        case "highlight.own":
          return value ? "Ja" : "Nein";
        case "category":
          return this.getCategoryTitle(value);
        case "features":
          return this.getFeatureTitle(value);
        case "locationObj.address.city":
          return this.mappedLocations.find(
            mLocation => mLocation.value === value
          )?.name;
        case "locationObj.address.normalized_city":
          return value.join(", ");
        case "location":
          return this.getLocationTitle(value);
        case "operator":
          return this.getOperatorTitle(value);
        case "active":
          return value ? "Ja" : "Nein";
        case "channels":
          return this.channels.find(channel => channel.value === value)?.title;
        case "regionality":
          return this.regionality.find(
            regionality => regionality.value === value
          )?.title;
        case "type":
          return this.selectableEventTypes.find(type => type.value === value)
            ?.name;
        case "change_date":
        case "create_date":
          return moment(value).format("DD.MM.YYYY");
        default:
          return value;
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    isEventAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:events_admin")
      );
    },
    eventConfig() {
      return this.$store.state.eventConfig;
    },
    mappedLocations() {
      const mappedLocations = [];
      this.locations.forEach(location => {
        if (location?.address?.city)
          mappedLocations.push({
            name: location.address.city,
            value: location.address.city
          });
      });
      return uniqBy(
        mappedLocations.sort((a, b) => a.value.localeCompare(b.value)),
        "value"
      );
    },
    mappedLocationsNormalized() {
      const mappedLocations = [];
      this.locations.forEach(location => {
        if (location?.address?.normalized_city)
          mappedLocations.push({
            title: location.address.normalized_city,
            _id: location.address.normalized_city
          });
      });
      let arr = uniqBy(
        mappedLocations.sort((a, b) => a._id.localeCompare(b._id)),
        "_id"
      );
      return [
        {
          title: "kein Standort",
          _id: "not-defined"
        },
        ...arr
      ];
    },
    mappedPrincipals() {
      const selectedPrincipal = this.$store.state.selectedPrincipal;
      const availablePrincipals = [
        {
          name: selectedPrincipal.name,
          value: selectedPrincipal._id
        }
      ];
      selectedPrincipal.subPrincipals.map(subPrincipal =>
        availablePrincipals.push({
          name: subPrincipal.name,
          value: subPrincipal._id
        })
      );
      return availablePrincipals.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
    },
    queryText() {
      let text = "";
      if (this.query && this.query[this.operator]?.length) {
        this.query[this.operator].forEach(filter => {
          const key = Object.keys(filter)[0];
          const op = Object.keys(filter[key])[0];
          const value = filter[key][op];
          const mappedKey = this.mapKey(key);
          const mappedOp = this.mapOp(op);
          const mappedValue = this.mapValue(key, value);
          const queryOp = this.operator === "$and" ? "und" : "oder";
          if (text.length > 0) text += ` ${queryOp} `;
          text += `${mappedKey} ${mappedOp} ${mappedValue}`;
        });
      }
      return text;
    },
    endBeforeStartDate() {
      const { start, end } = this.filter;
      if (!start || !end) {
        return false;
      }
      return new Date(start) >= new Date(end);
    }
  },
  watch: {
    async featuresDialog() {
      await this.updateFilter();
    }
  }
};
